(function () {
  'use strict';

  var referenceSelector = 'use[href="#junipOutlineStar"], use[href="#junipFilledStar"]';
  var junipSelector = referenceSelector + ', #junipOutlineStar, #junipFilledStar';
  var scheduled = false;

  function replaceReferences() {
    scheduled = false;

    var references = document.querySelectorAll(referenceSelector);
    for (var i = 0; i < references.length; i += 1) {
      var reference = references[i];
      var targetId = reference.getAttribute('href').slice(1);
      var symbol = document.getElementById(targetId);

      if (!symbol || !reference.parentNode || symbol.children.length === 0) continue;

      var fragment = document.createDocumentFragment();
      for (var j = 0; j < symbol.children.length; j += 1) {
        fragment.appendChild(symbol.children[j].cloneNode(true));
      }

      reference.parentNode.replaceChild(fragment, reference);
    }
  }

  function scheduleReplacement() {
    if (scheduled) return;
    scheduled = true;
    window.setTimeout(replaceReferences, 0);
  }

  function containsJunipSvg(node) {
    if (node.nodeType !== 1) return false;
    return node.matches(junipSelector) || Boolean(node.querySelector(junipSelector));
  }

  function watchJunip() {
    scheduleReplacement();

    var observer = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i += 1) {
        for (var j = 0; j < mutations[i].addedNodes.length; j += 1) {
          if (containsJunipSvg(mutations[i].addedNodes[j])) {
            scheduleReplacement();
            return;
          }
        }
      }
    });

    observer.observe(document.documentElement, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchJunip, { once: true });
  } else {
    watchJunip();
  }
})();
